import type { AppBarTone } from '../contexts/HeaderContext';

/** The gradient of a coloured header, per tone. Use with `bg-linear-68`. */
export const APP_BAR_TONES: Record<AppBarTone, string> = {
  focus: 'from-surface-focus/75 to-surface-focus',
  positive: 'from-green-600/75 to-green-600',
  warning: 'from-amber-600/75 to-amber-600',
  negative: 'from-red-600/75 to-red-600',
  neutral: 'from-neutral-500/75 to-neutral-500',
};
